const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const ORDERS_ENDPOINTS = {
  // Base endpoint
  BASE: `${API_BASE_URL}/orders`,

  // Create order (returns Stripe Checkout Session)
  CREATE: `${API_BASE_URL}/orders`,

  // Save shopping list as draft order (no payment)
  SAVE_DRAFT: `${API_BASE_URL}/orders/save`,

  // List orders with pagination and filtering
  LIST: `${API_BASE_URL}/orders`,

  // Get order details
  GET_BY_ID: (orderId: string) => `${API_BASE_URL}/orders/${orderId}`,

  // Cancel order (user initiated)
  CANCEL: (orderId: string) => `${API_BASE_URL}/orders/${orderId}/cancel`,

  // Get Stripe Checkout Session via order (secure method)
  GET_CHECKOUT_SESSION: (orderId: string) => `${API_BASE_URL}/orders/${orderId}/checkout-session`,

  // Update order status (future - not yet implemented)
  UPDATE_STATUS: (orderId: string) => `${API_BASE_URL}/orders/${orderId}/status`,
} as const;

export const STRIPE_ENDPOINTS = {
  // Get Stripe Checkout Session directly
  GET_SESSION: (sessionId: string) => `${API_BASE_URL}/stripe/checkout-session/${sessionId}`,

  // Webhook endpoint (backend only - not called from frontend)
  WEBHOOK: `${API_BASE_URL}/stripe/webhook`,
} as const;

export { API_BASE_URL };

export default ORDERS_ENDPOINTS;
